import { render } from "./RoleConflictListWidget.vue?vue&type=template&id=e06794fc&ts=true"
import script from "./RoleConflictListWidget.ts?vue&type=script&lang=ts&external"
export * from "./RoleConflictListWidget.ts?vue&type=script&lang=ts&external"

import "./RoleConflictListWidget.vue?vue&type=style&index=0&id=e06794fc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__